/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');


class SetPropertiesCommand extends RequestCommand {
	constructor(sheet, cellsColRows = {}, properties, ranges) {
		super(sheet);
		if (properties != null) {
			// only use
			const { attributes, formats, textFormats } = properties;
			properties = { attributes, formats, textFormats };
		}
		this._oldProperties = undefined;
		this._newProperties = cellsColRows;
		this._newProperties.properties = properties;

		this.saveSelection(ranges);
	}

	getExecuteRequest() {
		return this.createRequest(this._newProperties);
	}

	getRedoRequest() {
		return this.createRequest(this._newProperties);
	}

	getUndoRequest() {
		return this.createRequest(this._oldProperties);
	}

	handleResult(result) {
		const { oldProperties = {} } = result;
		if (!this._oldProperties) this._oldProperties = oldProperties;
	}
}
module.exports = SetPropertiesCommand;
